
export type Arc =
  | 'Fall of Shiganshina'
  | 'Training'
  | 'Trost'
  | 'Female Titan'
  | 'Clash of Titans'
  | 'Uprising'
  | 'Return to Shiganshina'
  | 'Marley'
  | 'War for Paradis';

export type Gender = 'Male' | 'Female';

export type Status = 'Alive' | 'Deceased';

export type Affiliation =
  | 'Scout Regiment'
  | 'Garrison'
  | 'Military Police'
  | 'Warriors'
  | 'Yeagerists'
  | 'Civilians'
  | 'Marleyan Military';

export type Species =
  | 'Human'
  | 'Titan Shifter';

export type Height = 'Short' | 'Average' | 'Tall';

export type Language = 'en' | 'tr' | 'es';
export type PageView = 'game' | 'privacy' | 'about' | 'contact' | 'characters' | 'guide' | 'trivia';

export interface AOTCharacter {
  id: string;
  name: string;
  gender: Gender;
  arc: Arc;
  arcNumber: number;
  affiliation: Affiliation;
  species: Species;
  height: Height;
  status: Status;
  quotes: Record<Language, string>;
  image: string;
  hasVerifiedQuote?: boolean;
}

export enum GameMode {
  CLASSIC = 'Classic',
  QUOTE = 'Quote',
  IMAGE = 'Image',
}

export interface GuessResult {
  character: AOTCharacter;
  isCorrect: boolean;
  comparisons: {
    gender: 'correct' | 'wrong';
    arc: 'correct' | 'wrong' | 'partial';
    arcDirection?: 'up' | 'down';
    affiliation: 'correct' | 'wrong';
    species: 'correct' | 'wrong';
    height: 'correct' | 'wrong' | 'partial';
    heightDirection?: 'up' | 'down';
    status: 'correct' | 'wrong';
  }
}

export interface GameState {
  mode: GameMode;
  guesses: GuessResult[];
  isWon: boolean;
  dailyCharacter: AOTCharacter | null;
  showHelp: boolean;
  showStats: boolean;
}
